import React from 'react';
import { motion } from 'framer-motion';
export function ProductMockup({
  title = 'La Biblia de la Milanesa',
  isBonus = false
}) {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.div whileHover={{
    y: -10,
    rotateY: -5
  }} onClick={scrollToCheckout} className={`relative cursor-pointer mx-auto shadow-2xl rounded-r-xl rounded-l-sm overflow-hidden flex flex-col items-center justify-center text-center p-6 border-l-8 border-bordo-dark
        ${isBonus ? 'w-48 h-64 bg-crema-dark' : 'w-64 h-80 md:w-80 md:h-96 bg-bordo text-crema'}`} style={{
    perspective: '1000px',
    transformStyle: 'preserve-3d'
  }} data-id="element-143">
      <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent w-full h-full pointer-events-none" data-id="element-144" />

      {!isBonus && <span className="text-4xl md:text-6xl mb-4" data-id="element-145">🥩</span>}
      <h3 className={`font-serif font-bold leading-tight ${isBonus ? 'text-bordo text-xl' : 'text-3xl md:text-4xl'}`} data-id="element-146">
        {title}
      </h3>
      {!isBonus && <p className="mt-4 text-sm md:text-base font-sans opacity-80 uppercase tracking-widest" data-id="element-147">
          El Sistema Definitivo
        </p>}

      {/* Book spine effect */}
      <div className="absolute left-0 top-0 bottom-0 w-2 bg-black/30" data-id="element-148" />
      <div className="absolute left-2 top-0 bottom-0 w-[1px] bg-white/20" data-id="element-149" />
    </motion.div>;
}